// extracted by mini-css-extract-plugin
export default {"otp-container":"otp-input_otp-container__MObgl","otp-input":"otp-input_otp-input__PEpHT"};